import React from "react";
import { graphql } from "gatsby";
import ExternalButton from "../elements/ExternalButton";
import { renderContent } from "../utils/utils";

export default function ImageCard(props) {
  const { imageData } = props;

  if (props.data) {
    return (
      <div className="grid grid-col-1 gap-xs px-6 py-3 sm:py-6 md:pb-16 md:pt-0 md:w-1/3 mx-auto field-tests-img">
        <img src={props.data.cardImage.url} className="mx-auto" alt=""/>
        <div
          dangerouslySetInnerHTML={renderContent(props.data.caption)}
          className="text-center text-newestFlavorGray"
        />
      </div>
    );
  } else {
    return (
      <div className="grid auto-cols-fr gap-3">
        <img src={imageData.url} className="block mx-auto" alt=""/>
        <ExternalButton {...props} />
      </div>
    );
  }
}

export const imageCardQuery = graphql`
  fragment ImageCardComponent on DatoCmsImageCard {
    buttonLink
    buttonText
    caption
    cardImage {
      alt
      url
      gatsbyImageData
    }
    buttonColor {
      hex
    }
    id
    internal {
      type
    }
  }
`;
